export default class QueryParamsUtils {
    static isUsingFilters = ({ params, isUsingPage }) => {
        const query = new URLSearchParams(params);
        const queryKeys = Array.from(query.keys());
        if (isUsingPage && queryKeys) {
            return !(queryKeys.length < 2 && queryKeys[0] === 'page');
        }
        return false;
    }
}